import React, { useEffect } from 'react';
import { IBasicModalProps } from '../../interfaces/IBasicModalProps';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { RecurrenceEditor } from '@catalytic-health-partners/common-components';
import { cleanRRuleString } from '../Utils/recurrenceUtils';

export interface IRecurrenceEditorModalProps extends IBasicModalProps {
    recurrenceString: string;
    onRecurrenceStringChange: (recurrenceString: string) => void;
    onDisplayTextChange?: (displayText: string) => void;
}

const RecurrenceEditorModal = (props: IRecurrenceEditorModalProps) => {
    const { recurrenceString, open, onClose, onRecurrenceStringChange } = props;
    const [ruleBuffer, setRuleBuffer] = React.useState<string>(recurrenceString || '');

    useEffect(() => {
        if (open) {
            setRuleBuffer(recurrenceString || '');
        }
    }, [open, recurrenceString]);

    const handleSave = () => {
        onRecurrenceStringChange(cleanRRuleString(ruleBuffer));
        onClose();
    };

    const isRuleUnchanged = cleanRRuleString(recurrenceString || '') === cleanRRuleString(ruleBuffer || '');

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Recurrence Editor</DialogTitle>
            <DialogContent>
                <RecurrenceEditor recurrenceString={ruleBuffer} onChange={(newRule: string) => setRuleBuffer(newRule)} />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleSave} color="success" disabled={isRuleUnchanged}>
                    Save
                </Button>
                <Button variant="contained" onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RecurrenceEditorModal;
